(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rudix-champagne-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wrapAnnounceChars = () => {
    document.querySelectorAll('.champagne-header__announce-text').forEach((el) => {
      if (el.dataset.charWrapped === '1') return;
      const raw = el.textContent || '';
      if (!raw) return;
      el.textContent = '';
      [...raw].forEach((ch, i) => {
        if (ch === ' ' || ch === '\t' || ch === '\n') {
          el.appendChild(document.createTextNode(ch));
          return;
        }
        const span = document.createElement('span');
        span.className = 'champagne-header__announce-char';
        span.style.setProperty('--i', String(i));
        span.textContent = ch;
        el.appendChild(span);
      });
      el.dataset.charWrapped = '1';
    });
  };
  wrapAnnounceChars();
  document.addEventListener('shopify:section:load', wrapAnnounceChars);

  const champagneCloseTimers = new WeakMap();
  const champagneFineHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const champagneClearClose = (el) => {
    const t = champagneCloseTimers.get(el);
    if (t) {
      clearTimeout(t);
      champagneCloseTimers.delete(el);
    }
  };
  const champagneCloseItem = (el) => {
    champagneClearClose(el);
    el.classList.remove('is-open');
    el.querySelector('.champagne-nav-item__trigger')?.setAttribute('aria-expanded', 'false');
  };

  document.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('[data-champagne-menu-close]');
    if (!closeBtn) return;
    event.preventDefault();
    const menu = closeBtn.closest('.champagne-menu');
    if (!menu) return;
    menu.open = false;
    menu.querySelectorAll('[data-champagne-sub-toggle][aria-expanded="true"]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
      const panel = btn.parentElement?.querySelector('.champagne-menu__subs');
      if (panel) panel.hidden = true;
    });
    menu.querySelector('summary')?.focus();
  });

  const setMenuTop = (menu) => {
    const header = menu.closest('.champagne-header');
    if (!header) return;
    const bottom = Math.ceil(header.getBoundingClientRect().bottom);
    header.style.setProperty('--champagne-menu-top', bottom + 'px');
  };

  const closeSubs = (root) => {
    root?.querySelectorAll('[data-champagne-sub-toggle][aria-expanded="true"]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
      const panel = btn.parentElement?.querySelector('.champagne-menu__subs');
      if (panel) panel.hidden = true;
    });
    root?.querySelectorAll('[data-champagne-fj-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
      const panel = btn.parentElement?.querySelector('.champagne-fj__links');
      if (panel) panel.hidden = true;
    });
  };

  const closeMenu = (menu) => {
    if (!menu) return;
    menu.open = false;
    closeSubs(menu);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('.champagne-menu[open]');
    if (!open) return;
    closeMenu(open);
    open.querySelector('summary')?.focus();
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.champagne-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) closeMenu(menu);
    });
    document.querySelectorAll('.champagne-nav-item--has-subs.is-open').forEach((item) => {
      if (!item.contains(event.target)) champagneCloseItem(item);
    });
  });

  document.querySelectorAll('.champagne-menu').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (menu.open) {
        setMenuTop(menu);
        requestAnimationFrame(() => setMenuTop(menu));
      } else {
        closeSubs(menu);
      }
    });
  });

  window.addEventListener('resize', () => {
    const open = document.querySelector('.champagne-menu[open]');
    if (open) setMenuTop(open);
  }, { passive: true });

  window.addEventListener('scroll', () => {
    const open = document.querySelector('.champagne-menu[open]');
    if (open) setMenuTop(open);
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const fjBtn = event.target.closest('[data-champagne-fj-toggle]');
    if (fjBtn) {
      event.preventDefault();
      event.stopPropagation();
      const links = fjBtn.parentElement?.querySelector('.champagne-fj__links');
      if (!links) return;
      const willOpen = fjBtn.getAttribute('aria-expanded') !== 'true';
      const wrap = fjBtn.closest('.champagne-fj--mobile');
      wrap?.querySelectorAll('[data-champagne-fj-toggle]').forEach((other) => {
        if (other === fjBtn) return;
        other.setAttribute('aria-expanded', 'false');
        const p = other.parentElement?.querySelector('.champagne-fj__links');
        if (p) p.hidden = true;
      });
      fjBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      links.hidden = !willOpen;
      return;
    }
    const btn = event.target.closest('[data-champagne-sub-toggle]');
    if (!btn) return;
    event.preventDefault();
    const panel = btn.parentElement?.querySelector('.champagne-menu__subs');
    if (!panel) return;
    const willOpen = btn.getAttribute('aria-expanded') !== 'true';
    const root = btn.closest('.champagne-menu__panel');
    root?.querySelectorAll('[data-champagne-sub-toggle]').forEach((other) => {
      if (other === btn) return;
      other.setAttribute('aria-expanded', 'false');
      const p = other.parentElement?.querySelector('.champagne-menu__subs');
      if (p) p.hidden = true;
    });
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    panel.hidden = !willOpen;
    if (!willOpen) {
      panel.querySelectorAll('[data-champagne-fj-toggle]').forEach((fj) => {
        fj.setAttribute('aria-expanded', 'false');
        const p = fj.parentElement?.querySelector('.champagne-fj__links');
        if (p) p.hidden = true;
      });
    }
  });

  document.querySelectorAll('.champagne-nav-item--has-subs > .champagne-nav-item__trigger').forEach((btn) => {
    const item = btn.parentElement;
    const sync = () => btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      champagneClearClose(item);
      const willOpen = !item.classList.contains('is-open');
      document.querySelectorAll('.champagne-nav-item--has-subs.is-open').forEach((el) => {
        if (el !== item) champagneCloseItem(el);
      });
      item.classList.toggle('is-open', willOpen);
      sync();
    });
    item.addEventListener('mouseenter', () => {
      if (!champagneFineHover()) return;
      champagneClearClose(item);
      document.querySelectorAll('.champagne-nav-item--has-subs.is-open').forEach((el) => {
        if (el !== item) champagneCloseItem(el);
      });
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', () => {
      if (!champagneFineHover()) return;
      champagneClearClose(item);
      const timer = setTimeout(() => {
        champagneCloseTimers.delete(item);
        item.classList.remove('is-open');
        sync();
      }, 200);
      champagneCloseTimers.set(item, timer);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudix-champagne-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('rudix-champagne-slider'))customElements.define('rudix-champagne-slider',class extends HTMLElement{
 connectedCallback(){this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-go]')];this.index=0;this.paused=false;this.abort=new AbortController();const options={signal:this.abort.signal};this.dots.forEach(dot=>dot.addEventListener('click',()=>{this.show(Number(dot.dataset.go));this.start()},options));this.pause=this.querySelector('[data-pause]');if(this.pause)this.pause.addEventListener('click',()=>{this.paused=!this.paused;this.pause.textContent=this.paused?'▷':'Ⅱ';this.pause.setAttribute('aria-label',this.paused?this.pause.dataset.playLabel:this.pause.dataset.pauseLabel);this.start()},options);const controls=this.querySelector('.champagne-slider-controls');if(controls){controls.addEventListener('mouseenter',()=>this.stop(),options);controls.addEventListener('mouseleave',()=>this.start(),options)}this.addEventListener('focusin',()=>this.stop(),options);this.addEventListener('focusout',()=>this.start(),options);this.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();this.show(this.index+1)}if(event.key==='ArrowLeft'){event.preventDefault();this.show(this.index-1)}},options);let startX=0,startY=0;this.addEventListener('touchstart',event=>{startX=event.changedTouches[0].clientX;startY=event.changedTouches[0].clientY},{...options,passive:true});this.addEventListener('touchend',event=>{const dx=event.changedTouches[0].clientX-startX,dy=event.changedTouches[0].clientY-startY;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)){this.show(this.index+(dx<0?1:-1));this.start()}},{...options,passive:true});document.addEventListener('visibilitychange',()=>document.hidden?this.stop():this.start(),options);document.addEventListener('shopify:block:select',event=>{const i=this.slides.findIndex(slide=>slide===event.target||slide.contains(event.target));if(i>=0){this.show(i);this.stop()}},options);this.initCountdowns(options);this.start()}
 show(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index});this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)))}
 stop(){clearInterval(this.timer)}
 start(){this.stop();if(this.dataset.autoplay!=='true'||this.paused||this.slides.length<2||document.hidden||this.matches(':focus-within')||matchMedia('(prefers-reduced-motion: reduce)').matches)return;this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)||7000)}
 initCountdowns(options){const pads=n=>String(n).padStart(2,'0');const tick=()=>{this.querySelectorAll('[data-champagne-cd]').forEach(el=>{const raw=el.getAttribute('data-end-iso')||'';const normalized=raw.replace(/([+-]\\d{2})(\\d{2})$/,'$1:$2');let end=Date.parse(normalized);if(!Number.isFinite(end))end=Date.parse(raw);if(!Number.isFinite(end))return;const remaining=end-Date.now();if(remaining<=0){el.hidden=true;return}const seconds=Math.floor(remaining/1000);const d=Math.floor(seconds/86400);const h=Math.floor((seconds%86400)/3600);const m=Math.floor((seconds%3600)/60);const s=seconds%60;const map={d:String(d),h:pads(h),m:pads(m),s:pads(s)};Object.keys(map).forEach(k=>{const node=el.querySelector('[data-cd-'+k+']');if(node)node.textContent=map[k]})})};tick();this.cdTimer=setInterval(tick,1000);this.abort.signal.addEventListener('abort',()=>clearInterval(this.cdTimer),{once:true})}
 disconnectedCallback(){this.stop();clearInterval(this.cdTimer);this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudix-custom-jewellery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rudix-custom-jewellery')) {
  customElements.define('rudix-custom-jewellery', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-start]');
        if (!link || !this.contains(link)) return;
        const select = this.querySelector('[data-starting-point]');
        if (select) {
          select.value = link.dataset.start;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudix-engagement-design"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rudix-ring-design')) {
  customElements.define('rudix-ring-design', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-start]');
        if (!link || !this.contains(link)) return;
        const select = this.querySelector('.rce-starting-point select, [data-starting-point]');
        if (select) { const values = {ideas:'I have some ideas',guidance:'I would like guidance',heirloom:'I have an heirloom to reimagine'}; select.value = select.hasAttribute('data-starting-point') ? link.dataset.start : values[link.dataset.start]; select.dispatchEvent(new Event('change', {bubbles:true})); }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rudix-offers-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
function updateOffers() {
document.querySelectorAll('[data-offers-hub]').forEach(hub => {
hub.querySelectorAll('[data-offer]').forEach(card => {
const end = Date.parse(card.dataset.end);
if (!Number.isFinite(end)) return;
const remaining = end - Date.now();
if (remaining <= 0) {
if(card.dataset.keep === 'true') {
card.classList.add('roh__archived');
card.querySelector('[data-offer-state]').textContent=hub.querySelector('[data-ended-text]').textContent;
card.querySelector('[data-offer-cta]')?.remove();
card.querySelector('[data-countdown-bar]')?.remove();
} else card.hidden=true;
} else {
const timer=card.querySelector('[data-countdown]');
if(timer) {
const seconds=Math.max(0,Math.floor(remaining/1000));
const values={days:Math.floor(seconds/86400),hours:Math.floor(seconds%86400/3600),minutes:Math.floor(seconds%3600/60),seconds:seconds%60};
Object.entries(values).forEach(([key,value])=>{const el=timer.querySelector('[data-clock="'+key+'"]');if(el)el.textContent=String(value).padStart(2,'0');});
}
}
});
hub.querySelector('[data-offers-empty]').hidden=!!hub.querySelector('[data-offer]:not([hidden])');
});
}
updateOffers();
setInterval(updateOffers,1000);
document.addEventListener('shopify:section:load',updateOffers);
})();

  } catch(e) { console.error(e); }
})();
})();
